var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wallet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.785 11.857v.89a1.78 1.78 0 0 1-1.78 1.78h-8.9a1.78 1.78 0 0 1-1.78-1.78v-6.23a1.78 1.78 0 0 1 1.78-1.78h8.9a1.78 1.78 0 0 1 1.78 1.78v.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.005 4.737-1.382-2.764a.89.89 0 0 0-1.194-.398L3.105 4.737M13.785 11.857a.89.89 0 0 0 .89-.89v-2.67a.89.89 0 0 0-.89-.89H11.56a2.225 2.225 0 1 0 0 4.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    d: "M11.667 8.667a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wallet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgWallet;